export default __webpack_public_path__ + "static/media/BladeRiskManagerLogo.6b45e275.png";